import { IntlShape } from 'react-intl'
import { IAlertType } from 'src/comps/AlertMessage'

import messages from 'src/comps/AlertMessage/messages'

const alertTitle = {
  loginSuccess: 'notification.success-login-title',
  signUpSuccess: 'notification.success-signup-title',
  priceWatchUnSubscriptionSuccess: 'notification.neutral-price-watch-deactivated-title',
  priceWatchNeutral: 'notification.neutral-price-watch-price-drop-title',
  priceWatchLoginSucess: 'pw.notification-title',
  propertyLikeLoginSucess: 'property-like.notification-title',
}

export function getAlertContent(intl: IntlShape, alert: IAlertType) {
  if ('description' in alert && alert.description) {
    return {
      title: alert.title,
      description: alert.description,
    }
  }

  if ('messageId' in alert) {
    const titleKey = alertTitle[alert.messageId as keyof typeof alertTitle]
    const { messageId, values } = alert
    const title = titleKey ? intl.formatMessage({ id: titleKey }) : alert.title
    const description = intl.formatMessage(messages[messageId], values)

    return {
      title,
      description,
    }
  }

  return null
}
